"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEDOPS_LOGGER_ID = void 0;
// it's put into separate module to avoid polluting widget lazy component, which uses this id to start app load
exports.FEDOPS_LOGGER_ID = 'cashier-payments-widget';
//# sourceMappingURL=constants.js.map